import { render } from "./Authentication.vue?vue&type=template&id=4d4241b7"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=4d4241b7&lang=scss"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__